import { executeMutation } from 'services/graphQL/clientService.js';
import gql from 'graphql-tag';

const mutation = gql`
  mutation RemoveAllTeamRewards($input: RemoveAllTeamRewardsInput!) {
    removeAllTeamRewards(input: $input) {
      success
      errors
    }
  }
`;

export default function removeAllRewards(input) {
  return executeMutation(mutation, { input });
}
